import { Button, Modal } from 'react-bootstrap';
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableList } from '@fortawesome/free-solid-svg-icons';
import themeColors from '../../../utils/contants/theme-colors';

// PER RIUTILIZZABILITA': i props vengono definiti come segue:
// modalTitle: rappresenta il TITOLO dell'heading del modale
// modalBody: nome componente da utilizzare/visualizzare all'interno del modale
// buttonType: tipologia del bottone inserito nel modale
// onConfirm: function attivata al click del pulsante di conferma
// labelConfirm: label da visualizzare sul pulsante di conferma
// onClose: function attivata al click del pulsante di chiusura

function ModaleCentroVerticale({
  modalTitle,
  modalBody,
  buttonType,
  onConfirm,
  disabledConfirm = false,
  disabledButtonConfirm = false,
  disabledClose = false,
  closeButton = true,
  labelConfirm,
  onClose,
  size,
  modalStyle,
  fullScreen = false,
  variantAI = false,
  modalIcon = <FontAwesomeIcon icon={faTableList} />,
  ...props
}) {
  return (
    <Modal
      {...props}
      size={fullScreen ? undefined : size || 'lg'}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={fullScreen}
      style={modalStyle}
    >
      <Modal.Header closeButton={closeButton} onHide={onClose} className="modalHeader">
        <div className="modalHeaderContent">
          <div className="modalIcon" style={{ color: themeColors.primary, pointerEvents: 'none' }}>
            {modalIcon}
          </div>
          <Modal.Title id="contained-modal-title-vcenter">
            {modalTitle}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        {modalBody}
      </Modal.Body>
      <Modal.Footer className="modalFooter">
        {!disabledClose && (
        <Button
          variant="outline-danger"
          type={buttonType}
          onClick={onClose}
        >
          Chiudi
        </Button>
        )}
        {!disabledConfirm && (
        <Button
          variant={variantAI ? 'outline-AI' : 'outline-primary'}
          type={buttonType}
          onClick={onConfirm}
          name="tasto-funzione"
          className={disabledClose ? 'ms-auto' : ''}
          disabled={disabledButtonConfirm}
        >
          {labelConfirm}
        </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ModaleCentroVerticale;
